<template>
    <div id="Wrapper">
        <div id="Header">
            <div id="Teilnehmer" style="text-align:center">
                <h2>99 - Max Mustermann</h2>
            </div>
            <div id="Klasse" style="text-align:center">
                <h3>Klasse: Einzel m&auml;nnlich 18 - 30 Jahre ab 2. Kup</h3>
            </div>
            <div id="Runde" style="text-align:center">
                <h4>Runde: 1 von 1</h4>
            </div>
        </div>
        <div :style="{
      display: 'flex',
      'flex-direction': 'column',
    }">
            <Stepper :value="step" :items="steps" :linear="true" />
            <br />
            <k-form ref="form" :class="'form-element'">
                <div>
                    <kRWertungTechnik v-if="step === 0" :reset="reset" />
                    <kRWertungPraesentation v-if="step === 1" :reset="reset" />
                    <kRWertungUebersicht v-if="step === 2" />
                </div>
            </k-form>
            <span :style="{ 'margin-top': '20px' }" :class="'k-form-separator'" />
            <div :style="{
        'justify-content': 'space-between',
        'align-content': 'center',
      }"
                 :class="'k-form-buttons'">
                <span :style="{ 'align-self': 'center' }">
                    Schritt {{ step + 1 }} von 3
                </span>
                <span>
                    <k-button :theme-color="'primary'" @click="nextSubmitButtonClick" style="font-size:xx-large">
                        {{ isLastStep ? 'N&auml;chster Sportler' : 'Weiter' }}
                    </k-button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store/store.js';
    import { Stepper } from '@progress/kendo-vue-layout';
    import { Form } from '@progress/kendo-vue-form';
    import { Button } from '@progress/kendo-vue-buttons';
    import KRWertungTechnik from '@/components/KRWertungTechnik.vue';
    import KRWertungPraesentation from '@/components/KRWertungPraesentation.vue';
    import KRWertungUebersicht from './KRWertungUebersicht.vue';

    export default {
        components: {
            'k-form': Form,
            Stepper,
            'k-button': Button,
            kRWertungTechnik: KRWertungTechnik,
            kRWertungPraesentation: KRWertungPraesentation,
            kRWertungUebersicht: KRWertungUebersicht,
            store
        },
        data: function () {
            return {
                disableNextStep: true,
                step: 0,
                steps: [
                    {
                        label: 'Technik',
                        componentName: 'kRWertungPraesentation',
                    },
                    {
                        label: 'Präsentation',
                        componentName: 'kRWertungTechnik',
                    },
                    {
                        label: 'Übersicht',
                        componentName: 'kRWertungUebersicht',
                    },
                ],
                reset: 0,
                posturl: '',
                postSummenurl: ''
            };
        },
        computed: {
            isLastStep() {
                return this.steps.length - 1 === this.step;
            }
        },
        mounted() {
            
        },
        created() {
            
        },
        methods: {
            stepperChange(event) {
                this.step = event.value;
            },
            nextSubmitButtonClick() {
                this.formErrors = this.$refs.form.form.errors;
                if (this.isLastStep) {
                    this.showErrors = false;
                    const formValues = this.$refs.form.form.values;
                    for (const property in formValues) {
                        if (formValues[property] === null || formValues[property] === '') {
                            this.showErrors = true;
                        }
                    }
                    if (!this.showErrors) {
                        setTimeout(() => {
                            this.step = 0;
                            this.reset += 1;
                        }, 2000);
                    }
                } else {
                    if (this.step === 0) {
                        this.step += 1;
                    }
                    else if (this.step === 1) {
                        this.step += 1;
                    }
                }
            },
            prevButtonClick() {
                this.step -= 1;
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .form-element {
        display: flex;
        justify-content: center;
    }
</style>